module.exports = __webpack_public_path__ + "img/icon.0a8416a4.png";